import { AttributeTypeFragment, DynamicAttributeType } from "gql/graphql";
import { useTranslations } from "use-intl";

export function AttributeType({
  attribute,
}: {
  attribute: AttributeTypeFragment;
}) {
  const t = useTranslations("DynamicAttributes");

  let type;

  switch (attribute.__typename) {
    case "SimpleTypeDynamicAttributeDto":
      switch (attribute.type) {
        case DynamicAttributeType.String:
          type = t("String");
          break;
        case DynamicAttributeType.Number:
          type = t("Number");
          break;
        case DynamicAttributeType.Float:
          type = t("Float");
          break;
        case DynamicAttributeType.Boolean:
          type = t("Boolean");
          break;
        case DynamicAttributeType.Date:
          type = t("Date");
          break;
        case DynamicAttributeType.DateTime:
          type = t("DateTime");
          break;
        default:
          type = t("Unknown");
      }
      break;
    case "EnumTypeDynamicAttributeDto":
      type = t("Enum");
      break;
    case "ReferenceTypeDynamicAttributeDto":
      type = t("Reference");
      break;
    default:
      type = t("Unknown");
  }

  return <span>{type}</span>;
}
